import React, {useState} from "react";
import { Modal } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

//Images
import feature1 from "../images/featured/ppi-map-icon.png";
import feature2 from "../images/featured/featured-history.png";
import feature3 from "../images/featured/featured-hgtv.png";
import feature4 from "../images/featured/featured-angles-list.png";
import mapBanner from "../images/featured/ppi-sales-map-icon-banner.png";

// Styles
import "./featured.scss";

const Featured = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const toggleModal = () => {
    if (showModal !== true) {
      setShowMap(false);
    }
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="row justify-content-center panel-featured">
        <div className="col-11 col-xl-10 content-wrapper">
          <div className="row justify-content-center featured-list">
            <div className="col-lg-10">
              <div className="row justify-content-around">
                <div 
                  className="map-icon col-5 col-md-3 mb-3 mb-md-0 text-center"
                  onClick={toggleModal}
                >
                  <img src={feature1} alt="Map icon" />
                  <p>
                      <span>We've installed over 15,000 jobs!</span>
                      <span>See if we're in your neighborhood!</span>
                  </p>
                </div>
                <div className="col-5 col-md-3 mb-3 mb-md-0 text-center">
                  <img src={feature2} alt="History" />
                </div>
                <div className="col-5 col-md-3 mb-3 mb-md-0 mt-3 mt-md-0 text-center">
                  <img src={feature3} alt="HGTV" />
                </div>
                <div className="col-5 col-md-3 mb-3 mb-md-0 mt-3 mt-md-0 text-center">
                  <img src={feature4} alt="Angles List" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={showModal}
        toggle={toggleModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        <button className="map-exit transition-3" onClick={toggleModal}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="modal-container">
          <iframe
            title="POL Sales Map"
            src="https://www.google.com/maps/d/embed?mid=13p8lLgUzww_k-pFrYQt1nm8d3EOrn6pN"
            width="100%"
            height="397"
          ></iframe>
          {!showMap && (
            <div className="featured-map" onClick={() => setShowMap(true)}>
              <img src={mapBanner} alt="" />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Featured;
